import initialState from '../initialState';
import * as types from './actionTypes.testMode';

let initialStateObj = {
    ...initialState.testMode,
};

export default function TestModeReducer(state = initialStateObj, action) {
    switch (action.type) {
        case types.GET_DIALOGS_CONTENT_OK:
            return {
                ...state,
                dialogs: action.dialogs,
                dialogTree: action.dialogTree,
            };

        case types.REFRESH_PHRASES_REQ:
            return {
                ...state,
                refreshingIsInProcess: true
            };

        case types.REFRESH_PHRASES_OK:
        case types.STOP_REFRESHING_ONE_DIALOG_REQ:
            return {
                ...state,
                refreshingIsInProcess: false
            };

        case types.REFRESH_DIALOGS_IN_CONVERSATION_REQ:
            return {
                ...state,
                dialogsInfo: {},
                isOneDialogRefreshingInProcess: true,
                refreshingIsInProcess: true,
                conversationsInfo: {}
            };

        case types.STOP_REFRESHING_DIALOG_OK:
            return {
                ...state,
                isDialogsRefreshingInProcess: false,
                isOneDialogRefreshingInProcess: false,
                refreshingIsInProcess: false,
                refreshDialogTreeCounter: {},
                refreshingDialogs: {}
            };

        case types.REFRESH_ALL_DIALOGS_REQ:
            return {
                ...state,
                dialogsInfo: {},
                isDialogsRefreshingInProcess: true,
                refreshingIsInProcess: true,
                conversationsInfo: {}
            };

        case types.REFRESH_ALL_DIALOGS_OK:
        case types.STOP_REFRESHING_ALL_DIALOGS_OK:
            return {
                ...state,
                isDialogsRefreshingInProcess: false,
                isOneDialogRefreshingInProcess: false,
                refreshingIsInProcess: false,
                refreshDialogTreeCounter: {},
                refreshingDialogs: {}
            };

        case types.UPDATE_REFRESH_ALL_DIALOGS_COUNTER_OK:
            return {
                ...state,
                refreshDialogTreeCounter: {
                    all: action.all !== undefined ? action.all : state?.refreshDialogTreeCounter?.all,
                    count: action.count !== undefined ? action.count : state?.refreshDialogTreeCounter?.count
                },
                conversationsInfo: {
                    ...state.conversationsInfo,
                    ...(action.conversationName ? (
                        { [action.conversationName]: action.status }
                    ) : {})
                }
            };

        case types.MARK_DIALOG_ACTUAL_REQ:
            return {
                ...state,
                actualDialogId: action.dialogId,
            };

        case types.START_REFRESHING_DIALOG_COUNTER_OK:
            return {
                ...state,
                refreshingDialogs: {
                    ...state.refreshingDialogs,
                    [action.dialogId]: {
                        count: action.count,
                        conversationId: action.conversationId
                    }
                },
            };

        case types.UPDATE_REFRESHING_DIALOG_COUNTER_OK:
            return {
                ...state,
                refreshingDialogs: {
                    ...state.refreshingDialogs,
                    [action.dialogId]: {
                        ...state.refreshingDialogs[action.dialogId] || {},
                        updated: {
                            ...state.refreshingDialogs[action.dialogId]?.updated || {},
                            [action.nodeId]: true
                        }
                    }
                },
            };

        case types.FINISH_REFRESHING_DIALOG_COUNTER_OK:
            return {
                ...state,
                refreshingDialogs: {
                    ...state.refreshingDialogs,
                    [action.dialogId]: null
                },
            };

        case types.SHOW_EXPECTED_RESPONSES_REQ:
            return {
                ...state,
                expectedResponsesAreShownGlobally: true,
            };

        case types.HIDE_EXPECTED_RESPONSES_REQ:
            return {
                ...state,
                expectedResponsesAreShownGlobally: false,
                dialogItemsWithOpenedExpectedResponses: {}
            };

        case types.SHOW_COMMANDS_IN_TEST_MODE_REQ:
            return {
                ...state,
                commandsInTestModeAreShownGlobally: true,
            };

        case types.HIDE_COMMANDS_IN_TEST_MODE_REQ:
            return {
                ...state,
                commandsInTestModeAreShownGlobally: false,
            };

        case types.SHOW_CODE_LINKS_REQ:
            return {
                ...state,
                codeLinksAreShownGlobally: true,
            };

        case types.HIDE_CODE_LINKS_REQ:
            return {
                ...state,
                codeLinksAreShownGlobally: false,
            };

        case types.ADD_DIALOG_ITEM_FROM_SYSTEM_MSG_REQ:
        case types.ADD_TEXT_DIALOG_ITEM_REQ:
        case types.UPDATE_TEXT_DIALOG_ITEM_REQ:
        case types.ADD_VISUAL_STATE_DIALOG_ITEM_REQ:
        case types.UPDATE_VISUAL_STATE_DIALOG_ITEM_REQ:
            return {
                ...state,
                activeDialogIdForQrCode: null,
            };

        case types.CONNECT_QR_CODE_TO_TEST_DIALOG_REQ:
            return {
                ...state,
                activeDialogIdForQrCode: action.id,
                activeDialogConnectedByQrCode: false,
            };

        case types.DEVICE_CONNECTED_BY_QR_CODE_OK:
            return {
                ...state,
                activeDialogConnectedByQrCode: true,
            };

        case types.DEVICE_DISCONNECTED_BY_QR_CODE_OK:
            return {
                ...state,
                activeDialogConnectedByQrCode: false,
            };

        case types.SHOW_EXPECTED_RESPONSES_FOR_DIALOG_ITEM_REQ:
            return {
                ...state,
                dialogItemsWithOpenedExpectedResponses: {
                    ...state.dialogItemsWithOpenedExpectedResponses,
                    ...{
                        [action.id]: true
                    }
                },
            };

        case types.ADD_EXPECTED_RESPONSE_REQ:
        case types.DELETE_EXPECTED_RESPONSE_REQ:
        case types.CHANGE_EXPECTED_RESPONSE_CONDITION_REQ:
            return {
                ...state,
                dialogItemsWithOpenedExpectedResponses: {
                    ...state.dialogItemsWithOpenedExpectedResponses,
                    ...{
                        [action.node.id]: true
                    }
                },
            };

        case types.COPY_EXPECTED_RESPONSE_OK:
            return {
                ...state,
                copiedExpectedResponses: {
                    ...action.copiedExpectedResponses,
                },
            };

        case types.COPY_DIALOG_OK:
            return {
                ...state,
                copiedNodes: [
                    ...action.copiedNodes,
                ],
            };

        case types.COLLECT_DIALOG_INFO_REQ:
            return {
                ...state,
                dialogsInfo: {
                    ...state.dialogsInfo,
                    [action.conversationId]: {}
                },
            };

        case types.COLLECT_DIALOG_INFO_OK:
            return {
                ...state,
                dialogsInfo: {
                    ...state.dialogsInfo,
                    [action.conversationId]: {
                        passed: action.passed,
                        failed: action.failed,
                    }
                },
            };

        default:
            return state;
    }
}